import { fetchAppsSaga } from '~/features/apps/sagas/appsSaga';

const sagas = [
    fetchAppsSaga,
];

export default sagas;
